import React, {useEffect, useState} from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // optional
import Collection_dropdown2 from '@components/dropdown/collection_dropdown2';
import {FileUploader} from 'react-drag-drop-files';
import Proparties_modal from '@components/modal/proparties_modal';
import {useDispatch} from 'react-redux';
import {showPropatiesModal} from '@redux/counterSlice';
import Meta from '@components/common/Meta';
import Captcha_modal from '@components/modal/captcha_modal';
import {CollectionItem} from '@redux/collectionSlice';
import {getMyCollectionApi} from '@api/collection';
import {
  // createItemApi,
  deleteItem,
  Attributes,
  createItemOnChain,
  CreateItemPayloadInterface,
  createItemLazyMint,
  CreateNftBatchResponseData,
  ItemInterface,
} from '@api/item';
import LoadingSpinner from '@components/common/loading-spinner';
import Properties_item from '@components/item/properties';
import Levels_item from '@components/item/levels';
import Stats_item from '@components/item/stats';
import {useMetaMask} from 'metamask-react';
import {useRouter} from 'next/router';
import {setNewItem} from '@redux/itemSlice';
import ItemFailedCreate_modal from '@components/modal/item_failed_create';
import VoucherModal from '@components/modal/voucherModal';
import {
  createVoucherClaimableNftApi,
  createVoucherClaimableNftBatchApi,
  CreateVoucherResponse,
  pollCreateNftQueueBatchJobStatus,
} from '@api/voucher';
import {useApp} from '@components/providers/app-provider';
import InfoTooltip from '@components/menu/info-tooltip';
import {Role} from '@api/user';
import {AxiosError} from 'axios';

interface Collection {
  id: number;
  name: string;
  logo_image: string;
  slug: string;
}

// This is in HEX
const DEFAULT_CHAIN_ID = process.env.NEXT_PUBLIC_BACKEND_CHAIN_ID as string;

const Create = () => {
  // const chains: any = [
  //   {chainName: 'Mumbai Testnet', chainId: '0x13881'},
  //   {chainName: 'Polygon', chainId: '0x89'},
  // ];

  const {user, jwt: token} = useApp();
  const {chainId, switchChain, account} = useMetaMask();
  const router = useRouter();
  const dispatch = useDispatch();
  const [collectionList, setCollectionList] = useState<Array<CollectionItem>>([]);
  const [isLoadingCollection, setIsLoadingCollection] = useState<boolean>(true);
  const [pageCollection, setPageCollection] = useState<number>(1);
  const [file, setFile] = useState<string>('');
  const fileTypes = [
    'JPG',
    'PNG',
    'GIF',
    'SVG',
    'MP4',
    'WEBM',
    'MP3',
    'WAV',
    'OGG',
    'GLB',
    'GLTF',
    'JPEG',
    'WEBP',
  ];
  const [attributesType, setAttributesType] = useState<string>('');
  const [attributesDesc, setAttributesDesc] = useState<string>('');
  const [openModalCreate, setOpenModalCreate] = useState<boolean>(false);
  const [openModalFailed, setOpenModalFailed] = useState<boolean>(false);
  const [preview, setPreview] = useState<string>();
  const [itemName, setItemName] = useState<string>();
  const [itemDescription, setItemDescription] = useState<string>();
  const [externalLink, setExternalLink] = useState<string>();
  const [collection, setCollection] = useState<Collection | null>(null);
  const [itemImage, setItemImage] = useState<string>('');
  const [supply, setSupply] = useState<number>(1);
  const [unlockable, setUnlockable] = useState<boolean>(false);
  const [explicitSensitive, setExplicitSensitive] = useState<boolean>(false);
  const [lazyMint, setLazyMint] = useState<boolean>(false);
  const [metadataFreeze, setMetadataFreeze] = useState<boolean>(true);
  const [attributes, setAttributes] = useState<Array<Attributes>>();
  const [blockchain, setBlockchain] = useState<number>(parseInt(DEFAULT_CHAIN_ID));
  const [isDisabledMint, setIsDisabledMint] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [properties, setProperties] = useState<Array<Attributes>>([]);
  const [levels, setLevels] = useState<Array<Attributes>>([]);
  const [stats, setStats] = useState<Array<Attributes>>([]);
  const [itemId, setItemId] = useState<number>(0);
  const [isError, setIsError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [generateVoucherEnabled, setGenerateVoucherEnabled] = useState<boolean>(false);
  const [voucherModalShow, setVoucherModalShow] = useState<boolean>(false);
  const [voucherData, setVoucherData] = useState<CreateVoucherResponse | null>(null);
  const [isCreateVoucherRedeemableNft, setIsCreateVoucherRedeemableNft] = useState<boolean>(false);
  const [isRightNetwork, setIsRightNetwork] = useState<boolean>(false);
  const [fungible, setFungible] = useState<boolean>(true);
  const [unique, setUnique] = useState<boolean>(false);
  const [descriptionLinkPrefix, setDescriptionLinkPrefix] = useState<string>('');
  const [invalidDescriptionLinkPrefix, setInvalidDescriptionLinkPrefix] = useState<boolean>(false);

  useEffect(() => {
    if (blockchain === parseInt(chainId as string)) {
      setIsRightNetwork(true);
      return;
    }
    setIsRightNetwork(false);
  }, [chainId]);

  const getCollection = async () => {
    if (pageCollection === 1) {
      setIsLoadingCollection(true);
    }
    const collection = await getMyCollectionApi({
      page: pageCollection,
    });
    console.log({collection});
    if (collection?.metadata?.pageCount >= pageCollection) {
      setPageCollection(pageCollection + 1);
    }
    if (!collection) return;

    setCollectionList([...collectionList, ...collection?.records]);
    setIsLoadingCollection(false);
  };

  // getCollection need to be authenticated
  // therfore need to check if token is ready first
  useEffect(() => {
    getCollection();
  }, [token]);

  useEffect(() => {
    getCollection();
  }, [pageCollection]);

  const handleChange = (file: any) => {
    console.log(file);
    setFile(file.name);
    setItemImage(file);
    setPreview(URL.createObjectURL(file as any));
  };

  const handleChangeName = (e: {target: {value: React.SetStateAction<string | undefined>}}) => {
    setItemName(e.target.value);
  };

  const handleChangeExternalLink = (e: {
    target: {value: React.SetStateAction<string | undefined>};
  }) => {
    setExternalLink(e.target.value);
  };

  const handleChangeDescription = (e: {
    target: {value: React.SetStateAction<string | undefined>};
  }) => {
    console.log({description: e.target.value});
    setItemDescription(e.target.value);
  };

  const handleChangeExplicit = (e: {
    target: {checked: boolean | ((prevState: boolean) => boolean)};
  }) => {
    setExplicitSensitive(e.target.checked);
  };

  const handleChangeLazyMint = (e: {
    target: {checked: boolean | ((prevState: boolean) => boolean)};
  }) => {
    setLazyMint(e.target.checked);
    if (!e.target.checked) {
      setGenerateVoucherEnabled(false);
    }
  };

  const handleChangeMetadataFreeze = (e: {
    target: {checked: boolean | ((prevState: boolean) => boolean)};
  }) => {
    setMetadataFreeze(e.target.checked);
  };

  const handleChangeSupply = (e: {target: {value: React.SetStateAction<string | undefined>}}) => {
    setSupply(Number(e.target.value));
  };

  const handleChangeDescriptionLinkPrefix = (e: {
    target: {value: React.SetStateAction<string | undefined>};
  }) => {
    setDescriptionLinkPrefix(String(e.target.value));
  };

  const isValidUrl = (urlString: string) => {
    try {
      return new Boolean(new URL(urlString));
    } catch (err) {
      return false;
    }
  };

  useEffect(() => {
    if (!descriptionLinkPrefix) {
      setInvalidDescriptionLinkPrefix(false);
      return;
    }
    if (!isValidUrl(descriptionLinkPrefix)) {
      setInvalidDescriptionLinkPrefix(true);
      return;
    }
    setInvalidDescriptionLinkPrefix(false);
  }, [descriptionLinkPrefix]);

  const handleAttributesModal = (type: string, desc: string) => {
    setAttributesType(type);
    setAttributesDesc(desc);
    setTimeout(() => {
      dispatch(showPropatiesModal());
    }, 100);
  };

  const handleUniquenessSelect = (e: any) => {
    const id = e.target.id;
    if (id == 'unique') {
      setUnique(true);
      setFungible(false);
    }
    if (id == 'fungible') {
      setFungible(true);
      setUnique(false);
    }
  };

  const popupItemData = [
    {
      id: 1,
      name: 'Properties',
      text: 'Textual traits that show up as rectangles.',
      icon: 'proparties-icon',
      desc: 'Item properties show up underneath your item, are clickable, and can be filtered in your collection`s sidebar.',
    },
    {
      id: 2,
      name: 'Levels',
      text: 'Numerical traits that show as a progress bar.',
      icon: 'level-icon',
      desc: 'Levels show up underneath your item, are clickable, and can be filtered in your collection`s sidebar.',
    },
    {
      id: 3,
      name: 'Stats',
      text: 'Numerical traits that just show as numbers.',
      icon: 'stats-icon',
      desc: 'Stats show up underneath your item, are clickable, and can be filtered in your collection`s sidebar.',
    },
  ];

  const enableGenerateVoucher = (e: any) => {
    setGenerateVoucherEnabled(e.target.checked);
    setLazyMint(e.target.checked);

    if (e.target.checked == true) {
      showGenerateVoucherModal();
    }
    if (e.target.checked == false) {
      setVoucherModalShow(false);
    }
  };

  const showGenerateVoucherModal = () => {
    setVoucherModalShow(true);
  };

  useEffect(() => {
    if (!!voucherData) {
      setIsCreateVoucherRedeemableNft(true);
    } else {
      setIsCreateVoucherRedeemableNft(false);
    }
  }, [voucherData]);

  const handleCreateItem = async () => {
    setErrorMessage('');
    setIsLoading(true);
    // const header = new Headers();
    // header.append('Authorization', `Bearer ${localStorage.getItem('JWT')}`);
    if (isDisabledMint) return;

    const createItemPayload: CreateItemPayloadInterface = {
      name: itemName as string,
      image: itemImage,
      description: itemDescription,
      external_link: externalLink,
      collection_id: collection?.id as number,
      supply,
      unlockable,
      explicit_sensitive: explicitSensitive,
      is_metadata_freeze: metadataFreeze,
      attributes,
      chainId: blockchain,
      is_unique: unique,
      description_link_prefix: descriptionLinkPrefix,
    };

    try {
      /// Create Voucher NFTs 1 ID Multiple Items (Fungible)
      if (isCreateVoucherRedeemableNft && fungible) {
        const item = (await createItemLazyMint(createItemPayload)) as ItemInterface;
        const res = await createVoucherClaimableNftApi({
          walletAddress: account as string,
          metadataUri: item?.metadata as string,
          voucherHashes: voucherData?.leaves as string[],
          voucherRootHash: voucherData?.rootHash as string,
          itemUuid: item?.uuid as string,
        });
        // Wait a little bit for the item to be created on blockchain
        // TODO: find a better way to do this. Maybe use web3 to listen to the event
        await new Promise((resolve) => setTimeout(resolve, 5000));
        dispatch(setNewItem(item));
        router.push(`/item/${item?.id}`);

        return;
      }

      /// Create Voucher NFTs 1 ID for 1 Item (Unique)
      if (isCreateVoucherRedeemableNft && unique) {
        const response = (await createItemLazyMint(
          createItemPayload,
        )) as CreateNftBatchResponseData;
        const {uris, uuids} = response;
        const job = await createVoucherClaimableNftBatchApi({
          toAddress: account as string,
          uris: uris,
          voucherHashes: voucherData?.leaves as string[],
          itemUuids: uuids,
        });
        const jobWatch = pollCreateNftQueueBatchJobStatus(job.id);
        let progress = await jobWatch.next();
        while (!progress.done) {
          console.log({progress});
          progress = await jobWatch.next();
        }
        router.push(`/collection/${collection?.slug}`);
        return;
      }

      if (lazyMint && unique) {
        const response = (await createItemLazyMint(
          createItemPayload,
        )) as CreateNftBatchResponseData;
        // const {uris, uuids} = response;
        router.push(`/collection/${collection?.slug}`);
        return;
      }

      /// Lazy Mint
      if (lazyMint) {
        const item = (await createItemLazyMint(createItemPayload)) as ItemInterface;
        dispatch(setNewItem(item));
        router.push(`/item/${item?.id}`);

        return;
      }

      /// Mint On Chain
      if (!lazyMint && !isCreateVoucherRedeemableNft) {
        const item = await createItemOnChain(createItemPayload);
        if (createItemPayload.is_unique) {
          router.push(`/collection/${collection?.slug}`);
          return;
        }
        dispatch(setNewItem(item));
        router.push(`/item/${item?.id}`);
      }
    } catch (error) {
      setIsError(true);
      setIsLoading(false);
      setOpenModalFailed(true);
      console.log({error});
      const axiosError = error as AxiosError<any>;
      const metamaskError = error as {action: string; code: string; reason: string};
      if (axiosError?.response?.data?.message) {
        setErrorMessage(axiosError?.response?.data?.message);
      } else if (metamaskError.action) {
        setErrorMessage(metamaskError?.reason);
      } else {
        setErrorMessage('');
      }
    } finally {
      setIsLoading(false);
      setOpenModalCreate(false);
    }
  };

  useEffect(() => {
    if (isError && (itemId !== 0 || itemId !== undefined)) {
      deleteItem(itemId);
      setIsError(false);
    }
  }, [isError]);

  useEffect(() => {
    console.log({itemName, itemImage, itemDescription, collection, supply});
    if (itemName && itemImage && itemDescription && supply && !invalidDescriptionLinkPrefix)
      setIsDisabledMint(false);
    else setIsDisabledMint(true);
    console.log({isDisabledMint, isRightNetwork});
  }, [itemName, itemImage, itemDescription, collection, supply]);

  useEffect(() => {
    if (attributes) {
      setProperties(attributes?.filter((item) => item.nusa_attribute_type === 'PROPERTIES'));
      setLevels(attributes?.filter((item) => item.nusa_attribute_type === 'LEVELS'));
      setStats(attributes?.filter((item) => item.nusa_attribute_type === 'STATS'));
    }
  }, [attributes]);

  return (
    <div>
      <Meta
        title="Create || Nusa | NFT Marketplace"
        desc="Make new item in your collection of NFT in the Polygon Network to attract and engage better with your potential market"
      />
      {/* <!-- Create --> */}
      <section className="relative py-24">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <img src="/images/gradient_light.jpg" alt="gradient" className="h-full w-full" />
        </picture>
        <div className="container">
          <h1 className="font-display text-dark-navy py-16 text-center text-4xl font-medium dark:text-white">
            Create Item on Collection
          </h1>

          <div className="mx-auto max-w-[48.125rem]">
            {/* <!-- Collection --> */}
            <div className="relative mb-6 mt-3">
              <div>
                <label className="font-display text-dark-navy mb-2 block dark:text-white">
                  Collection
                  <span className="text-red">*</span>
                </label>
                <div className="mb-3 flex items-center space-x-2">
                  <p className="dark:text-grey text-dark-grey text-2xs">
                    This is the collection where your item will appear.
                  </p>
                </div>
              </div>

              {/* dropdown */}
              <div className="dropdown my-1 cursor-pointer">
                <Collection_dropdown2
                  data={collectionList}
                  collection={true}
                  value={collection}
                  setValue={setCollection}
                  loading={isLoadingCollection}
                />
              </div>
            </div>
            {/* <!-- File Upload --> */}
            <div className="mb-6">
              <label className="font-display text-dark-navy mb-2 block dark:text-white">
                Image, Video, Audio, or 3D Model
                <span className="text-red">*</span>
              </label>

              {itemImage ? (
                <p className="dark:text-grey text-2xs mb-3">successfully uploaded : {file}</p>
              ) : (
                <p className="dark:text-grey text-dark-grey text-2xs mb-3">
                  Drag or choose your file to upload
                </p>
              )}

              <div
                className={`
                  dark:bg-black-green-2 dark:border-grey border-light-grey group
                  flex max-w-md flex-col items-center justify-center rounded-lg border-2 border-dashed bg-white 
                  text-center relative
                  ${preview ? 'py-5' : 'py-28'} px-5
                `}
              >
                {preview && (
                  <img src={preview as string} alt="Preview" style={{margin: '0 auto'}} />
                )}
                {!preview && (
                  <div className="absolute z-1 cursor-pointer">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      className="fill-jacarta-500 mb-4 inline-block dark:fill-grey"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M16 13l6.964 4.062-2.973.85 2.125 3.681-1.732 1-2.125-3.68-2.223 2.15L16 13zm-2-7h2v2h5a1 1 0 0 1 1 1v4h-2v-3H10v10h4v2H9a1 1 0 0 1-1-1v-5H6v-2h2V9a1 1 0 0 1 1-1h5V6zM4 14v2H2v-2h2zm0-4v2H2v-2h2zm0-4v2H2V6h2zm0-4v2H2V2h2zm4 0v2H6V2h2zm4 0v2h-2V2h2zm4 0v2h-2V2h2z" />
                    </svg>
                    <p className="dark:text-grey text-dark-grey mx-auto max-w-xs text-xs">
                      JPG, PNG, GIF, SVG, MP4, WEBM, MP3, WAV, OGG, GLB, GLTF. Max size: 100 MB
                    </p>
                  </div>
                )}
                <div className="dark:bg-jacarta-600 bg-jacarta-50 absolute inset-4 cursor-pointer rounded opacity-0 ">
                  <FileUploader
                    handleChange={handleChange}
                    name="file"
                    types={fileTypes}
                    classes="file-drag"
                    maxSize={100}
                    minSize={0}
                  />
                </div>
              </div>
            </div>

            {/* <!-- Name --> */}
            <div className="mb-6">
              <label
                htmlFor="item-name"
                className="font-display text-dark-navy mb-2 block dark:text-white"
              >
                Name<span className="text-red">*</span>
              </label>
              <input
                type="text"
                id="item-name"
                className="dark:bg-black-green-2 border-light-grey hover:green-light focus:ring-green-2 focus:border-transparent dark:border-dark-grey dark:placeholder:text-grey w-full rounded-lg py-3 px-3  dark:text-white text-dark-grey placeholder:text-grey placeholder:text-grey/[.70]"
                placeholder="Item name"
                required
                onChange={handleChangeName}
              />
            </div>

            {/* <!-- External Link --> */}
            <div className="mb-6">
              <label
                htmlFor="item-external-link"
                className="font-display text-dark-navy mb-2 block dark:text-white"
              >
                External link
              </label>
              <p className="dark:text-grey text-dark-grey text-2xs mb-3">
                We will include a link to this URL on this {"item's"} detail page, so that users can
                click to learn more about it. You are welcome to link to your own webpage with more
                details.
              </p>
              <input
                type="url"
                id="item-external-link"
                className="dark:bg-black-green-2 border-light-grey hover:green-light focus:ring-green-2 focus:border-transparent dark:border-dark-grey dark:placeholder:text-grey w-full rounded-lg py-3 px-3  dark:text-white text-dark-grey placeholder:text-grey/[.70]"
                placeholder="https://yoursite.io/item/123"
                onChange={handleChangeExternalLink}
              />
            </div>

            {/* <!-- Description --> */}
            <div className="mb-6">
              <label
                htmlFor="item-description"
                className="font-display text-dark-navy mb-2 block dark:text-white"
              >
                Description
                <span className="text-red">*</span>
              </label>
              <p className="dark:text-grey text-dark-grey text-2xs mb-3">
                The description will be included on the {"item's"} detail page underneath its image.
                <br />
                Maximal 1000 characters.
              </p>
              <textarea
                id="item-description"
                className="dark:bg-black-green-2 border-light-grey hover:green-light focus:ring-green-2 focus:border-transparent dark:border-dark-grey dark:placeholder:text-dark-grey w-full rounded-lg py-3 px-3  dark:text-white text-dark-grey placeholder:text-grey/[.70]"
                rows={4}
                required
                placeholder="Provide a detailed description of your item."
                onChange={handleChangeDescription}
                maxLength={1000}
              ></textarea>
            </div>

            {/* <!-- Propertieses --> */}
            {popupItemData.map(({id, name, text, icon, desc}) => {
              return (
                <div
                  key={id}
                  className="dark:border-black-green border-light-grey relative border-b py-6"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex">
                      <svg className="icon fill-dark-navy mr-2 mt-px h-4 w-4 shrink-0 dark:fill-white">
                        <use xlinkHref={`/icons.svg#icon-${icon}`}></use>
                      </svg>

                      <div>
                        <label className="font-display text-dark-navy block dark:text-white">
                          {name}
                        </label>
                        <p className="dark:text-grey text-dark-grey">{text}</p>
                      </div>
                    </div>
                    <button
                      className="group dark:bg-white/[.30] border dark:border-[#FFF] dark:rounded-lg gradient-border-create-item flex h-12 w-12 shrink-0 items-center justify-center bg-white "
                      onClick={() => handleAttributesModal(name, desc)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        className="dark:fill-white fill-green-3  "
                      >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z" />
                      </svg>
                    </button>
                  </div>
                  {name === 'Properties' && properties.length > 0 && (
                    <div className="mt-7 grid lg:grid-cols-4 grid-cols-2 pl-5">
                      {properties.map((item: Attributes, index) => {
                        return <Properties_item key={index} item={item} />;
                      })}
                    </div>
                  )}

                  {name === 'Levels' && levels.length > 0 && (
                    <div className="mt-7 pl-5">
                      {levels.map((item: Attributes, index) => {
                        return <Levels_item key={index} item={item} />;
                      })}
                    </div>
                  )}

                  {name === 'Stats' && stats.length > 0 && (
                    <div className="mt-7 pl-5">
                      {stats.map((item: Attributes, index) => {
                        return <Stats_item key={index} item={item} />;
                      })}
                    </div>
                  )}
                </div>
              );
            })}

            <Proparties_modal
              type={attributesType}
              description={attributesDesc}
              onSave={(value: any) => setAttributes(value)}
            />

            {/* <!-- Propertieses --> */}

            {/* <!-- Explicit & Sensitive Content --> */}
            <div className="dark:border-black-green border-light-grey relative border-b py-6">
              <div className="flex items-center justify-between">
                <div className="flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    className="fill-dark-navy mr-2 mt-px h-4 w-4 shrink-0 dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M12.866 3l9.526 16.5a1 1 0 0 1-.866 1.5H2.474a1 1 0 0 1-.866-1.5L11.134 3a1 1 0 0 1 1.732 0zM11 16v2h2v-2h-2zm0-7v5h2V9h-2z" />
                  </svg>

                  <div>
                    <label className="font-display text-dark-navy dark:text-white">
                      Explicit & Sensitive Content
                    </label>

                    <p className="dark:text-grey text-dark-grey">
                      Set this item as explicit and sensitive content.
                    </p>
                  </div>
                </div>
                <input
                  type="checkbox"
                  value="checkbox"
                  name="check"
                  className="checked:bg-green-2 checked:focus:bg-green-2 checked:hover:bg-green-2 after:bg-jacarta-400 bg-jacarta-100 relative h-6 w-[2.625rem] cursor-pointer appearance-none rounded-full border-none after:absolute after:top-[0.1875rem] after:left-[0.1875rem] after:h-[1.125rem] after:w-[1.125rem] after:rounded-full after:transition-all checked:bg-none checked:after:left-[1.3125rem] checked:after:bg-white focus:ring-transparent focus:ring-offset-0"
                  onChange={handleChangeExplicit}
                />
              </div>
            </div>

            <div className="dark:border-black-green border-light-grey relative mb-6 border-b py-6">
              <div className="flex items-center justify-between">
                <div className="flex">
                  <div>
                    <label className="font-display text-dark-navy dark:text-white">
                      Lazy Mint{' '}
                      <Tippy
                        theme="tomato-theme"
                        content={
                          <div className="p-2 !text-[10px]">
                            Lazy mint item cannot be auctioned, and can only be sold by direct
                            listing (Auction will be available after the item is purchased)
                          </div>
                        }
                      >
                        <span className="inline-block">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            className="dark:fill-jacarta-300 fill-grey/[.90] ml-1 -mb-[3px] h-4 w-4"
                          >
                            <path fill="none" d="M0 0h24v24H0z"></path>
                            <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z"></path>
                          </svg>
                        </span>
                      </Tippy>
                    </label>

                    <p className="dark:text-grey text-dark-grey">
                      Enable lazy minting. Item is not minted until the first sale.
                    </p>
                  </div>
                </div>
                <input
                  type="checkbox"
                  value="checkbox"
                  name="check"
                  checked={lazyMint}
                  className="checked:bg-green-2 checked:focus:bg-green-2 checked:hover:bg-green-2 after:bg-jacarta-400 bg-jacarta-100 relative h-6 w-[2.625rem] cursor-pointer appearance-none rounded-full border-none after:absolute after:top-[0.1875rem] after:left-[0.1875rem] after:h-[1.125rem] after:w-[1.125rem] after:rounded-full after:transition-all checked:bg-none checked:after:left-[1.3125rem] checked:after:bg-white focus:ring-transparent focus:ring-offset-0"
                  onChange={handleChangeLazyMint}
                />
              </div>
            </div>

            {/* <!-- Supply --> */}
            <div className="mb-6">
              <label
                htmlFor="item-supply"
                className="font-display text-dark-navy mb-2 block dark:text-white"
              >
                Supply
                <span className="text-red">*</span>
                <InfoTooltip text={`supply can not be 0`} />
              </label>

              <div className="mb-3 flex items-center space-x-2">
                <p className="dark:text-grey text-dark-grey text-2xs">
                  The number of items that can be minted.
                </p>
              </div>

              <input
                readOnly={generateVoucherEnabled}
                type="text"
                id="item-supply"
                className="dark:bg-black-green-2 border-light-grey hover:green-light focus:ring-green-2 focus:border-transparent dark:border-dark-grey dark:placeholder:text-grey w-full rounded-lg py-3 px-3 dark:text-white text-dark-grey placeholder:text-grey/[.70]"
                placeholder="1"
                onChange={handleChangeSupply}
                value={supply}
              />
            </div>

            {(user?.roles?.includes(Role.SUPER_ADMIN) || user?.roles?.includes(Role.ADMIN)) && (
              <>
                <div className="mb-6">
                  <div className="flex space-x-5">
                    {/* Fungible: 1 ID Multiple Items */}
                    <div className="flex items-center space-x-3">
                      <input
                        type="radio"
                        id="fungible"
                        checked={fungible}
                        className="checked:!bg-green-2 checked:!bg-none dark:bg-white text-dark-navy focus:ring-accent/20  h-4 w-4 self-start rounded-focus:ring-offset-0 cursor-pointer  checked:border dark:!border-white border-light-grey rounded-full"
                        onChange={(e) => {
                          handleUniquenessSelect(e);
                        }}
                      />
                      <label
                        htmlFor="fungible"
                        className="font-display text-dark-navy block dark:text-white"
                      >
                        Fungible (1 ID for multiple items)
                      </label>
                    </div>

                    {/* Unique: 1 ID 1 Item */}
                    <div className="flex items-center space-x-3">
                      <input
                        type="radio"
                        id="unique"
                        checked={unique}
                        className="checked:!bg-green-2 checked:!bg-none dark:bg-white text-dark-navy focus:ring-accent/20  h-4 w-4 self-start rounded-focus:ring-offset-0 cursor-pointer dark:!border-white border-light-grey rounded-full"
                        onChange={(e) => {
                          handleUniquenessSelect(e);
                        }}
                      />
                      <label
                        htmlFor="unique"
                        className="font-display text-dark-navy block dark:text-white"
                      >
                        Unique (1 ID for 1 Item)
                      </label>
                    </div>
                  </div>
                </div>

                {/* Generate Voucher */}
                <div className="dark:border-black-green relative mb-6">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <svg
                        className="mr-2"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_1809_5776)">
                          <path
                            d="M11.9991 5.50833C11.9991 6.67083 11.9991 7.83333 11.9991 8.99924C11.9991 9.52424 11.6774 9.90265 11.167 9.99129C11.104 10.0015 11.0376 10.0049 10.9712 10.0049C8.99912 10.0049 7.0271 10.0049 5.05857 10.0049C4.65647 10.0049 4.35577 9.83447 4.16696 9.48674C4.08304 9.33333 3.95717 9.23788 3.77185 9.23788C3.58304 9.23447 3.45367 9.32992 3.36626 9.49015C3.17745 9.83788 2.87675 10.0083 2.47115 10.0083C1.98864 10.0083 1.50262 10.0083 1.0201 10.0083C0.425699 10.0083 0.00262238 9.60265 0.00262238 9.02311C-0.000874126 6.67424 -0.000874126 4.32879 0.00262238 1.98674C0.00262238 1.4072 0.425699 1.00492 1.0236 1.00152C1.51661 1.00152 2.00961 0.998106 2.50262 1.00152C2.88374 1.00492 3.17395 1.17197 3.35577 1.49583C3.45017 1.66288 3.57255 1.77197 3.77535 1.76856C3.97115 1.76515 4.09003 1.65606 4.18094 1.49583C4.36276 1.17197 4.65297 1.00492 5.03409 1.00492C7.01661 1.00152 9.00262 1.00152 10.9851 1.00152C11.5795 1.00152 11.9956 1.41061 11.9991 1.99356C12.0026 3.16629 11.9991 4.33902 11.9991 5.50833ZM3.35227 3.39129C3.35227 3.51742 3.34878 3.64697 3.35227 3.77311C3.36276 3.98106 3.5271 4.14129 3.73689 4.15492C3.94668 4.16856 4.14598 4.03561 4.17045 3.83106C4.20542 3.5447 4.20542 3.25152 4.17045 2.96515C4.14598 2.76061 3.94668 2.62424 3.73689 2.63788C3.53059 2.65152 3.36276 2.81174 3.35227 3.0197C3.34528 3.14583 3.35227 3.26856 3.35227 3.39129ZM3.35227 7.60492C3.35227 7.72765 3.34878 7.85379 3.35227 7.97652C3.36276 8.18447 3.5271 8.34811 3.73339 8.36515C3.94668 8.3822 4.14948 8.24242 4.17395 8.03106C4.20892 7.74811 4.20892 7.46174 4.17395 7.17879C4.14948 6.97083 3.95367 6.83447 3.74388 6.84811C3.5271 6.86174 3.36276 7.02197 3.35227 7.23674C3.34528 7.35947 3.35227 7.4822 3.35227 7.60492ZM3.35227 5.50492C3.35227 5.62424 3.34878 5.74356 3.35227 5.86288C3.35927 6.08106 3.53059 6.25152 3.75087 6.26174C3.95367 6.27197 4.15297 6.12879 4.17395 5.92083C4.20542 5.64129 4.20542 5.35833 4.17395 5.07879C4.14948 4.87424 3.95017 4.73106 3.74388 4.7447C3.5271 4.75833 3.36276 4.92197 3.35227 5.13333C3.34528 5.25606 3.35227 5.3822 3.35227 5.50492Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1809_5776">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <div>
                        <label className="font-display text-dark-navy dark:text-white">
                          Generate Voucher
                        </label>
                      </div>
                    </div>

                    <div className="flex items-center space-x-2">
                      <input
                        disabled={supply === 0}
                        type="checkbox"
                        value="checkbox"
                        name="check"
                        checked={generateVoucherEnabled}
                        className="checked:bg-green-2 checked:focus:bg-green-2 checked:hover:bg-green-2 after:bg-jacarta-400 bg-jacarta-100 relative h-6 w-[2.625rem] cursor-pointer appearance-none rounded-full border-none after:absolute after:top-[0.1875rem] after:left-[0.1875rem] after:h-[1.125rem] after:w-[1.125rem] after:rounded-full after:transition-all checked:bg-none checked:after:left-[1.3125rem] checked:after:bg-white focus:ring-transparent focus:ring-offset-0"
                        onChange={enableGenerateVoucher}
                      />
                    </div>
                  </div>
                </div>

                <div className="mb-6 dark:border-black-green border-light-grey border-b pb-4">
                  <label
                    htmlFor="description-link-prefix"
                    className="font-display text-dark-navy mb-2 block dark:text-white"
                  >
                    Description Link Prefix
                    {/*<span className="text-red">*</span> */}
                  </label>
                  <p className="dark:text-grey text-dark-grey text-2xs mb-3">
                    If description link prefix is set, a link will be appended to your nft metadata
                    description.
                    <br />
                    For example, https://nft.nusa.finance/event_register will result in
                    https://nft.nusa.finance/event_register/uuid.
                  </p>
                  <input
                    type="text"
                    id="description-link-prefix"
                    className="dark:bg-black-green-2 border-light-grey hover:green-light focus:ring-green-2 focus:border-transparent dark:border-dark-grey dark:placeholder:text-grey w-full rounded-lg py-3 px-3 dark:text-white text-dark-grey placeholder:text-grey/[.70]"
                    placeholder="https://nft.nusa.finance/event_register"
                    onChange={handleChangeDescriptionLinkPrefix}
                    value={descriptionLinkPrefix}
                  />
                  {invalidDescriptionLinkPrefix && (
                    <div className="mt-2">
                      <span className="text-red">Invalid URL format</span>
                    </div>
                  )}
                </div>
              </>
            )}

            {/* <!-- Blockchain --> */}
            <div className="mb-6">
              <label
                htmlFor="item-supply"
                className="font-display text-dark-navy mb-2 block dark:text-white"
              >
                Blockchain
                <span className="text-red">*</span>
              </label>

              {/* dropdown */}
              <div className="dropdown relative mb-4 cursor-pointer ">
                <div className="dark:bg-black-green-2 border border-light-grey hover:green-light focus:ring-green-2 focus:border-transparent dark:border-dark-grey dark:placeholder:text-grey w-full rounded-lg py-3 px-3  dark:text-light-grey flex gap-x-2 items-center text-dark-grey">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_1119_3569)">
                      <path
                        d="M10.6842 4.53155C10.4263 4.38419 10.0947 4.38419 9.8 4.53155L7.73684 5.74734L6.33684 6.52103L4.31053 7.73682C4.05263 7.88419 3.72105 7.88419 3.42632 7.73682L1.84211 6.77892C1.58421 6.63155 1.4 6.33682 1.4 6.00524V4.16313C1.4 3.8684 1.54737 3.57366 1.84211 3.38945L3.42632 2.4684C3.68421 2.32103 4.01579 2.32103 4.31053 2.4684L5.89474 3.42629C6.15263 3.57366 6.33684 3.8684 6.33684 4.19997V5.41576L7.73684 4.60524V3.35261C7.73684 3.05787 7.58947 2.76313 7.29474 2.57892L4.34737 0.847343C4.08947 0.699974 3.75789 0.699974 3.46316 0.847343L0.442105 2.61576C0.147368 2.76313 0 3.05787 0 3.35261V6.81576C0 7.1105 0.147368 7.40524 0.442105 7.58945L3.42632 9.32103C3.68421 9.4684 4.01579 9.4684 4.31053 9.32103L6.33684 8.14208L7.73684 7.33155L9.76316 6.15261C10.0211 6.00524 10.3526 6.00524 10.6474 6.15261L12.2316 7.07366C12.4895 7.22103 12.6737 7.51576 12.6737 7.84734V9.68945C12.6737 9.98419 12.5263 10.2789 12.2316 10.4631L10.6842 11.3842C10.4263 11.5316 10.0947 11.5316 9.8 11.3842L8.21579 10.4631C7.95789 10.3158 7.77368 10.021 7.77368 9.68945V8.5105L6.37368 9.32103V10.5368C6.37368 10.8316 6.52105 11.1263 6.81579 11.3105L9.8 13.0421C10.0579 13.1894 10.3895 13.1894 10.6842 13.0421L13.6684 11.3105C13.9263 11.1631 14.1105 10.8684 14.1105 10.5368V7.03682C14.1105 6.74208 13.9632 6.44734 13.6684 6.26313L10.6842 4.53155Z"
                        fill="#9AA09D"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1119_3569">
                        <rect width="14" height="14" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  Polygon
                </div>
              </div>
            </div>

            {/* <!-- Freeze metadata --> */}
            <div className="dark:border-black-green border-light-grey relative mb-6 border-b py-6">
              <div className="flex items-center justify-between">
                <div className="flex">
                  <div>
                    <label className="font-display text-dark-navy dark:text-white">
                      Freeze metadata
                    </label>

                    <p className="dark:text-grey text-dark-grey">
                      Freezing your metadata will allow you to permanently lock and store all of
                      this item&apos;s content in decentralized file storage.
                    </p>
                  </div>
                </div>

                {/* Disabled dulu karena bugs on the backend */}
                <input
                  type="checkbox"
                  value="checkbox"
                  name="check"
                  //checked={metadataFreeze}
                  checked={true}
                  className="checked:bg-green-2 checked:focus:bg-green-2 checked:hover:bg-green-2 after:bg-jacarta-400 bg-jacarta-100 relative h-6 w-[2.625rem] cursor-pointer appearance-none rounded-full border-none after:absolute after:top-[0.1875rem] after:left-[0.1875rem] after:h-[1.125rem] after:w-[1.125rem] after:rounded-full after:transition-all checked:bg-none checked:after:left-[1.3125rem] checked:after:bg-white focus:ring-transparent focus:ring-offset-0"
                  //onChange={handleChangeMetadataFreeze}
                  onChange={() => {}}
                />
              </div>
            </div>

            {/* <!-- Submit --> */}

            {!isRightNetwork ? (
              <>
                <button
                  onClick={() => switchChain(DEFAULT_CHAIN_ID)}
                  className={
                    'bg-green-gradation-light rounded-full py-3 px-8 text-center font-semibold text-white transition-all'
                  }
                >
                  Switch network
                </button>
                <div className="text-red mt-2 text-sm">Please change your network to first !</div>
              </>
            ) : (
              <button
                disabled={isDisabledMint || !isRightNetwork}
                onClick={() => setOpenModalCreate(true)}
                className={
                  !isDisabledMint && isRightNetwork
                    ? 'bg-green-gradation-light rounded-full py-3 px-8 text-center font-semibold text-white transition-all'
                    : 'bg-black-green rounded-full py-3 px-8 text-center font-semibold text-white transition-all'
                }
              >
                {isLoading ? <LoadingSpinner /> : 'Create'}
              </button>
            )}
          </div>
        </div>
        <Captcha_modal
          open={openModalCreate}
          onClose={() => setOpenModalCreate(false)}
          onAccept={handleCreateItem}
          header={'Almost Done!'}
          description={
            'Before this item gets created, please check the box below to let us know you’re human.'
          }
        />
        <ItemFailedCreate_modal
          open={openModalFailed}
          onClose={() => setOpenModalFailed(false)}
          data={preview as string}
          message={errorMessage}
        />
        <VoucherModal
          show={voucherModalShow}
          quantity={supply}
          onClose={() => enableGenerateVoucher({target: {checked: false}})}
          onSave={(voucherData) => {
            setVoucherData(voucherData);
            setVoucherModalShow(false);
          }}
        />
      </section>
      {/* <!-- end create --> */}
    </div>
  );
};

export default Create;
